import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Stack } from '@mui/material';

import { StepConnector, StepDot } from './signup.styled';

export type StepDotState = 'done' | 'current' | 'upcoming';

const resolveState = (index: number, current: number): StepDotState => {
  if (index < current) return 'done';
  if (index === current) return 'current';
  return 'upcoming';
};

const StepDots: React.FC<{ total: number; current: number }> = ({
  total,
  current,
}) => (
  <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
    {Array.from({ length: total }, (_, index) => {
      const state = resolveState(index, current);
      return (
        <React.Fragment key={index}>
          {index > 0 && <StepConnector $reached={index <= current} />}
          <StepDot $state={state}>
            {state === 'done' ? (
              <CheckRoundedIcon sx={{ fontSize: 16 }} />
            ) : (
              index + 1
            )}
          </StepDot>
        </React.Fragment>
      );
    })}
  </Stack>
);

export default StepDots;
